import SummaryReportWithPreviewImage from "Areas/SummaryReports/summaryReportWithPreviewImage";
import ClickableArea from "Components/clickableArea";
import Scrollbars from "Components/scrollbars";
import classNames from "classnames";
import map from "lodash/map";
import React, { useCallback, useEffect } from "react";
import locale from "./summaryReportList.locale";
import styles from "./summaryReportList.module.css";
export default function SummaryReportList(props) {
    var _a;
    useEffect(() => {
        props.projectId && props.onInitialized && props.onInitialized(props.projectId);
    }, [props.projectId, props.onInitialized]);
    const handleCreateSummaryReport = useCallback(() => {
        props.projectId &&
            props.onOpenSummaryReportCreatorPanel &&
            props.onOpenSummaryReportCreatorPanel(props.projectId);
    }, [props.projectId, props.onOpenSummaryReportCreatorPanel]);
    if (!props.projectId)
        return null;
    return (React.createElement("div", { className: "h-100 grid-rows-auto-1fr" },
        React.createElement("div", { className: classNames(!props.data && "invisible", "w-fit-content mb-1 text-muted bg-gray-100 border-rounded-base pr-0_5 pl-0_5") }, locale.buildCountSummaryReportsTitle(((_a = props.data) === null || _a === void 0 ? void 0 : _a.length) || 0)),
        React.createElement(Scrollbars, null,
            React.createElement("div", { className: "d-flex self-start flex-wrap with-gap-12 pr-0_5 pb-1px" },
                props.canEdit && (React.createElement(ClickableArea, { title: locale.CREATE_SUMMARY_REPORT, className: styles["add-btn"], iconColor: "create-report-color", bgColor: "create-report-bg", bgColorHover: "create-report-bg-hover", bgColorActive: "create-report-bg-active", borderColor: "create-report-border", borderColorHover: "create-report-border-hover", borderColorActive: "create-report-border-active", icon: "icon-add", width: 260, height: 147, onClick: handleCreateSummaryReport })),
                map(props.data, summaryReport => (React.createElement(SummaryReportWithPreviewImage, { key: summaryReport.Id, summaryReport: summaryReport, width: 260, height: 147 })))))));
}
